import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Subject, Observable } from 'rxjs';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  confirm = new Subject<boolean>();
  constructor() { }

  showNotification(from: string, align: string, type: string, message: string) {
    if (type === 'green') {
      type = 'success';
    } else if (type === 'red') {
      type = 'danger';
    } else if (type === 'yellow') {
      type = 'warning';
    }

    const timer = (type === 'success' || type === 'warning') ? 2000 : null;

    $.notify({
      icon: 'ti-gift',
      message: message
    }, {
      type: type,
      timer: timer,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-11 col-md-4 alert alert-{0} alert-with-icon Zindex" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="nc-icon nc-simple-remove"></i></button><span data-notify="icon" class="nc-icon nc-bell-55"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
    });
  }

  showErrorNotification(errorMessage: string, buttonText: string): Observable<boolean> {
    Swal.fire({
      title: errorMessage,
      type: 'error',
      confirmButtonText: buttonText,
      confirmButtonClass: 'btn btn-danger',
      buttonsStyling: false,
    }).then((response) => {
      this.confirm.next(response.value)
    })

    return this.confirm.asObservable();
  }
}
